import { createSelector } from '@reduxjs/toolkit';
import getData from '../getData';

/**
 * Возвращает текущую страницу пагинации для cars
 */
const getCurrentPage = createSelector(getData, data => data.page);

export default getCurrentPage;
